<template>
  <CInput
    :autofocus="autofocus"
    class="c-search flex items-center justify-center"
    :class="{
      'c-search--no-border': hideBorder,
      'c-search--transparent': transparent,
      'text-sm': size === 'small',
      'text-md': size === 'large',
    }"
    clearable
    :loading="loading"
    :placeholder="placeholder ?? t('canvasUI.components.search.placeholder')"
    :value="search"
    @update:value="
      (v) => {
        emit('update:modelValue', v)
        emit('update:search', v)
      }
    "
  >
    <template #prefix>
      <CIcon v-if="showIcon" faType="fal" icon="search" size="20px" />
    </template>
    <template #clear-icon>
      <CIcon class="relative -right-1" faType="fas" icon="circle-xmark" size="24px" />
    </template>
  </CInput>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import CInput from '@lib/components/CInput/CInput.vue'

type Props = {
  autofocus?: boolean
  transparent?: boolean
  hideBorder?: boolean
  showIcon?: boolean
  search?: string
  size?: 'small' | 'large'
  placeholder?: string
  loading?: boolean
}

withDefaults(defineProps<Props>(), {
  autofocus: false,
  hideBorder: false,
  showIcon: false,
  transparent: false,
  loading: false,
  size: 'small',
})

const emit = defineEmits<{
  (e: 'update:modelValue', term: string): void
  (e: 'update:search', term: string): void // added so we can do v-model:search="search"
}>()

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.c-search {
  &--no-border {
    :deep(.n-input__border),
    :deep(.n-input__state-border) {
      display: none;
    }
  }

  &--transparent.n-input {
    background-color: transparent;
  }
}

:deep(.n-base-clear) {
  width: 100%;
}
</style>
